import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from "@/components/ui/card";

const Guidelines: React.FC = () => {
	const guidelines = [
		{
			id: "preparation",
			title: "事前準備",
			description: "参加前に必要な準備について",
			items: [
				"開発環境のセットアップ",
				"事前課題の確認（該当する場合）",
				"必要なアカウントの準備",
				"参加方法の確認",
			],
		},
		{
			id: "rules",
			title: "参加ルール",
			description: "円滑な勉強会進行のために",
			items: [
				"時間厳守での参加",
				"積極的な質問・発言",
				"他の参加者への配慮",
				"ハラスメント行為の禁止",
			],
		},
		{
			id: "tools",
			title: "使用ツール",
			description: "オンライン参加に必要なツール",
			items: [
				"Zoom（ビデオ会議）",
				"Slack（コミュニケーション）",
				"GitHub（コード共有）",
				"Google Drive（資料共有）",
			],
		},
	];

	return (
		<section className="py-16">
			<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
				<h2 className="text-3xl font-bold mb-8">参加ガイドライン</h2>
				<div className="grid md:grid-cols-3 gap-6">
					{guidelines.map((guideline) => (
						<Card key={guideline.id}>
							<CardHeader>
								<CardTitle>{guideline.title}</CardTitle>
								<CardDescription>{guideline.description}</CardDescription>
							</CardHeader>
							<CardContent>
								<ul className="list-disc list-inside space-y-2">
									{guideline.items.map((item) => (
										<li key={item} className="text-gray-600">
											{item}
										</li>
									))}
								</ul>
							</CardContent>
						</Card>
					))}
				</div>
			</div>
		</section>
	);
};

export default Guidelines;
